const Tools = require('../../deploynaut/js/tools.jsx');
const Secrets = require('./Secrets.jsx');

Tools.install(Secrets, 'Secrets');

